import React, { useState } from 'react'
import ValidDomainInput from './ValidDomainInput'
import { Button, Typography } from '@mui/material'

export interface ValidDomainInputListProps {
  value: string
  onChange: (e: string) => void
}

const ValidDomainInputList = (props: ValidDomainInputListProps) => {
  const [validDomains, setValidDomains] = useState<string[]>(props.value ? props.value.split(',') : ['*'])

  const handleAddInput = () => {
    const updatedDomains = [...validDomains, validDomains.length == 0 ? '*' : '']
    setValidDomains(updatedDomains)
    props.onChange(updatedDomains.join(','))
  }

  const handleRemoveInput = (index: number) => {
    const updatedDomains = [...validDomains]
    if (updatedDomains.length > 1) {
      updatedDomains.splice(index, 1)
      setValidDomains(updatedDomains)
      props.onChange(updatedDomains.join(','))
    }
  }

  const handleInputChange = (index: number, value: string) => {
    const updatedDomains = [...validDomains]
    updatedDomains[index] = value
    setValidDomains(updatedDomains)
    props.onChange(updatedDomains.join(','))
  }

  return (
    <div>
      <Typography variant="caption" component="div" sx={{ marginBottom: 2 }}>Enter websites where this API key will be used. For anywhere use asterisk. Cannot be modified later. Wildcards not supported. <strong>Note:</strong> Only if you add a valid domain, you can use the generated API key for embedding into your website</Typography>
      {validDomains.map((domain, index) => (
        <ValidDomainInput
          id={index}
          key={index}
          value={domain}
          last={index === validDomains.length - 1}
          onChange={(e) => handleInputChange(index, e.target.value)}
          onRemove={() => handleRemoveInput(index)}
          onAdd={handleAddInput}
        />
      ))}
    </div>
  )
}


export default ValidDomainInputList